import Route from "@ember/routing/route";

export default class ObjectStorageDetailsRoute extends Route {
  async model(params) {
    let { project } = this.modelFor("organization");

    return { project, instanceId: params.object_storage_id };
  }
}
